/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Bank Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ApprovalType = typeof ApprovalType[keyof typeof ApprovalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApprovalType = {
  BANK_CREATE: 'BANK_CREATE',
  BANK_UPDATE: 'BANK_UPDATE',
  PRODUCT_CREATE: 'PRODUCT_CREATE',
  PRODUCT_UPDATE: 'PRODUCT_UPDATE',
  PRODUCT_RATE_UPDATE: 'PRODUCT_RATE_UPDATE',
  PRODUCT_RATE_UPDATE_PROPOSED: 'PRODUCT_RATE_UPDATE_PROPOSED',
  PRODUCT_CLOSE: 'PRODUCT_CLOSE',
  PRODUCT_CLOSE_PROPOSED: 'PRODUCT_CLOSE_PROPOSED',
  PRODUCT_SOFT_CLOSE: 'PRODUCT_SOFT_CLOSE',
  PRODUCT_SOFT_CLOSE_PROPOSED: 'PRODUCT_SOFT_CLOSE_PROPOSED',
  PAYMENT_ACCOUNT_UPDATE: 'PAYMENT_ACCOUNT_UPDATE',
} as const;
